import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { CATALOG_URL } from 'src/constants/global'
import type { ColumnDefinition, JsonValue } from 'src/types/tableDataSet'

export const useCatalog = (): DatasetListResponse =>
  useFetch<DatasetListResponse>(CATALOG_URL + '/v1/datasets')

export const useDataset = (id: string): DatasetGetResponse =>
  useFetch<DatasetGetResponse>(CATALOG_URL + '/v1/datasets/' + id)

export const useDatasetData = (id: string): DatasetDataResponse =>
  useFetch<DatasetDataResponse>(CATALOG_URL + '/v1/datasets/' + id + '/data')

export interface DatasetEntry {
  id: string
  title: string
  description: string
  schema: string
  tableName: string
  taxonomy: string[]
  owner: string
  featured: boolean
  lastUpdate?: string
  connector?: string
  connectorId?: string
}

export interface DatasetPagination {
  page: number
  itemsPerPage: number
  totalPages: number
}

export interface DatasetListResponse {
  ok: boolean
  datasets: DatasetEntry[]
  pagination: DatasetPagination
}

export interface OwnerType {
  id: string
  name: string
  nif: string
}

export interface DatasetGetResponse {
  ok: boolean
  dataset: DatasetEntry
  colSpec: ColumnDefinition[]
  sampleData: Record<string, JsonValue>[]
  owner: OwnerType
}
export interface DatasetDataResponse {
  ok: boolean
  data: Record<string, JsonValue>[]
  colSpec: ColumnDefinition[]
  pagination: DatasetPagination
}
